export const CURRENCY_MAP: Record<
  string,
  { currency: string; name: string; countryCode: string }
> = {
  USD: { currency: "USD", name: "United States Dollar", countryCode: "US" },
  AED: {
    currency: "AED",
    name: "United Arab Emirates Dirham",
    countryCode: "AE",
  },
  AFN: { currency: "AFN", name: "Afghan Afghani", countryCode: "AF" },
  ALL: { currency: "ALL", name: "Albanian Lek", countryCode: "AL" },
  AMD: { currency: "AMD", name: "Armenian Dram", countryCode: "AM" },
  ANG: {
    currency: "ANG",
    name: "Netherlands Antillean Guilder",
    countryCode: "CW",
  },
  AOA: { currency: "AOA", name: "Angolan Kwanza", countryCode: "AO" },
  ARS: { currency: "ARS", name: "Argentine Peso", countryCode: "AR" },
  AUD: { currency: "AUD", name: "Australian Dollar", countryCode: "AU" },
  AWG: { currency: "AWG", name: "Aruban Florin", countryCode: "AW" },
  AZN: { currency: "AZN", name: "Azerbaijani Manat", countryCode: "AZ" },
  BAM: {
    currency: "BAM",
    name: "Bosnia-Herzegovina Convertible Mark",
    countryCode: "BA",
  },
  BBD: { currency: "BBD", name: "Barbadian Dollar", countryCode: "BB" },
  BDT: { currency: "BDT", name: "Bangladeshi Taka", countryCode: "BD" },
  BGN: { currency: "BGN", name: "Bulgarian Lev", countryCode: "BG" },
  BHD: { currency: "BHD", name: "Bahraini Dinar", countryCode: "BH" },
  BIF: { currency: "BIF", name: "Burundian Franc", countryCode: "BI" },
  BMD: { currency: "BMD", name: "Bermudan Dollar", countryCode: "BM" },
  BND: { currency: "BND", name: "Brunei Dollar", countryCode: "BN" },
  BOB: { currency: "BOB", name: "Bolivian Boliviano", countryCode: "BO" },
  BRL: { currency: "BRL", name: "Brazilian Real", countryCode: "BR" },
  BSD: { currency: "BSD", name: "Bahamian Dollar", countryCode: "BS" },
  BTN: { currency: "BTN", name: "Bhutanese Ngultrum", countryCode: "BT" },
  BWP: { currency: "BWP", name: "Botswanan Pula", countryCode: "BW" },
  BYN: { currency: "BYN", name: "Belarusian Ruble", countryCode: "BY" },
  BZD: { currency: "BZD", name: "Belize Dollar", countryCode: "BZ" },
  CAD: { currency: "CAD", name: "Canadian Dollar", countryCode: "CA" },
  CDF: { currency: "CDF", name: "Congolese Franc", countryCode: "CD" },
  CHF: { currency: "CHF", name: "Swiss Franc", countryCode: "CH" },
  CLP: { currency: "CLP", name: "Chilean Peso", countryCode: "CL" },
  CNY: { currency: "CNY", name: "Chinese Yuan", countryCode: "CN" },
  COP: { currency: "COP", name: "Colombian Peso", countryCode: "CO" },
  CRC: { currency: "CRC", name: "Costa Rican Colón", countryCode: "CR" },
  CUP: { currency: "CUP", name: "Cuban Peso", countryCode: "CU" },
  CVE: { currency: "CVE", name: "Cape Verdean Escudo", countryCode: "CV" },
  CZK: { currency: "CZK", name: "Czech Koruna", countryCode: "CZ" },
  DJF: { currency: "DJF", name: "Djiboutian Franc", countryCode: "DJ" },
  DKK: { currency: "DKK", name: "Danish Krone", countryCode: "DK" },
  DOP: { currency: "DOP", name: "Dominican Peso", countryCode: "DO" },
  DZD: { currency: "DZD", name: "Algerian Dinar", countryCode: "DZ" },
  EGP: { currency: "EGP", name: "Egyptian Pound", countryCode: "EG" },
  ERN: { currency: "ERN", name: "Eritrean Nakfa", countryCode: "ER" },
  ETB: { currency: "ETB", name: "Ethiopian Birr", countryCode: "ET" },
  EUR: {
    currency: "EUR",
    name: "Euro",
    countryCode: "DE",
  },
  FJD: { currency: "FJD", name: "Fijian Dollar", countryCode: "FJ" },
  FKP: { currency: "FKP", name: "Falkland Islands Pound", countryCode: "FK" },
  FOK: { currency: "FOK", name: "Faroese Króna", countryCode: "FO" },
  GBP: { currency: "GBP", name: "British Pound Sterling", countryCode: "GB" },
  GEL: { currency: "GEL", name: "Georgian Lari", countryCode: "GE" },
  GGP: { currency: "GGP", name: "Guernsey Pound", countryCode: "GG" },
  GHS: { currency: "GHS", name: "Ghanaian Cedi", countryCode: "GH" },
  GIP: { currency: "GIP", name: "Gibraltar Pound", countryCode: "GI" },
  GMD: { currency: "GMD", name: "Gambian Dalasi", countryCode: "GM" },
  GNF: { currency: "GNF", name: "Guinean Franc", countryCode: "GN" },
  GTQ: { currency: "GTQ", name: "Guatemalan Quetzal", countryCode: "GT" },
  GYD: { currency: "GYD", name: "Guyanaese Dollar", countryCode: "GY" },
  HKD: { currency: "HKD", name: "Hong Kong Dollar", countryCode: "HK" },
  HNL: { currency: "HNL", name: "Honduran Lempira", countryCode: "HN" },
  HRK: { currency: "HRK", name: "Croatian Kuna", countryCode: "HR" },
  HTG: { currency: "HTG", name: "Haitian Gourde", countryCode: "HT" },
  HUF: { currency: "HUF", name: "Hungarian Forint", countryCode: "HU" },
  IDR: { currency: "IDR", name: "Indonesian Rupiah", countryCode: "ID" },
  ILS: { currency: "ILS", name: "Israeli New Shekel", countryCode: "IL" },
  IMP: { currency: "IMP", name: "Manx Pound", countryCode: "IM" },
  INR: { currency: "INR", name: "Indian Rupee", countryCode: "IN" },
  IQD: { currency: "IQD", name: "Iraqi Dinar", countryCode: "IQ" },
  IRR: { currency: "IRR", name: "Iranian Rial", countryCode: "IR" },
  ISK: { currency: "ISK", name: "Icelandic Króna", countryCode: "IS" },
  JEP: { currency: "JEP", name: "Jersey Pound", countryCode: "JE" },
  JMD: { currency: "JMD", name: "Jamaican Dollar", countryCode: "JM" },
  JOD: { currency: "JOD", name: "Jordanian Dinar", countryCode: "JO" },
  JPY: { currency: "JPY", name: "Japanese Yen", countryCode: "JP" },
  KES: { currency: "KES", name: "Kenyan Shilling", countryCode: "KE" },
  KGS: { currency: "KGS", name: "Kyrgystani Som", countryCode: "KG" },
  KHR: { currency: "KHR", name: "Cambodian Riel", countryCode: "KH" },
  KID: { currency: "KID", name: "Kiribati Dollar", countryCode: "KI" },
  KMF: { currency: "KMF", name: "Comorian Franc", countryCode: "KM" },
  KRW: { currency: "KRW", name: "South Korean Won", countryCode: "KR" },
  KWD: { currency: "KWD", name: "Kuwaiti Dinar", countryCode: "KW" },
  KYD: { currency: "KYD", name: "Cayman Islands Dollar", countryCode: "KY" },
  KZT: { currency: "KZT", name: "Kazakhstani Tenge", countryCode: "KZ" },
  LAK: { currency: "LAK", name: "Laotian Kip", countryCode: "LA" },
  LBP: { currency: "LBP", name: "Lebanese Pound", countryCode: "LB" },
  LKR: { currency: "LKR", name: "Sri Lankan Rupee", countryCode: "LK" },
  LRD: { currency: "LRD", name: "Liberian Dollar", countryCode: "LR" },
  LSL: { currency: "LSL", name: "Lesotho Loti", countryCode: "LS" },
  LYD: { currency: "LYD", name: "Libyan Dinar", countryCode: "LY" },
  MAD: { currency: "MAD", name: "Moroccan Dirham", countryCode: "MA" },
  MDL: { currency: "MDL", name: "Moldovan Leu", countryCode: "MD" },
  MGA: { currency: "MGA", name: "Malagasy Ariary", countryCode: "MG" },
  MKD: { currency: "MKD", name: "Macedonian Denar", countryCode: "MK" },
  MMK: { currency: "MMK", name: "Myanmar Kyat", countryCode: "MM" },
  MNT: { currency: "MNT", name: "Mongolian Tugrik", countryCode: "MN" },
  MOP: { currency: "MOP", name: "Macanese Pataca", countryCode: "MO" },
  MRU: { currency: "MRU", name: "Mauritanian Ouguiya", countryCode: "MR" },
  MUR: { currency: "MUR", name: "Mauritian Rupee", countryCode: "MU" },
  MVR: { currency: "MVR", name: "Maldivian Rufiyaa", countryCode: "MV" },
  MWK: { currency: "MWK", name: "Malawian Kwacha", countryCode: "MW" },
  MXN: { currency: "MXN", name: "Mexican Peso", countryCode: "MX" },
  MYR: { currency: "MYR", name: "Malaysian Ringgit", countryCode: "MY" },
  MZN: { currency: "MZN", name: "Mozambican Metical", countryCode: "MZ" },
  NAD: { currency: "NAD", name: "Namibian Dollar", countryCode: "NA" },
  NGN: { currency: "NGN", name: "Nigerian Naira", countryCode: "NG" },
  NIO: { currency: "NIO", name: "Nicaraguan Córdoba", countryCode: "NI" },
  NOK: { currency: "NOK", name: "Norwegian Krone", countryCode: "NO" },
  NPR: { currency: "NPR", name: "Nepalese Rupee", countryCode: "NP" },
  NZD: { currency: "NZD", name: "New Zealand Dollar", countryCode: "NZ" },
  OMR: { currency: "OMR", name: "Omani Rial", countryCode: "OM" },
  PAB: { currency: "PAB", name: "Panamanian Balboa", countryCode: "PA" },
  PEN: { currency: "PEN", name: "Peruvian Sol", countryCode: "PE" },
  PGK: { currency: "PGK", name: "Papua New Guinean Kina", countryCode: "PG" },
  PHP: { currency: "PHP", name: "Philippine Peso", countryCode: "PH" },
  PKR: { currency: "PKR", name: "Pakistani Rupee", countryCode: "PK" },
  PLN: { currency: "PLN", name: "Polish Złoty", countryCode: "PL" },
  PYG: { currency: "PYG", name: "Paraguayan Guaraní", countryCode: "PY" },
  QAR: { currency: "QAR", name: "Qatari Rial", countryCode: "QA" },
  RON: { currency: "RON", name: "Romanian Leu", countryCode: "RO" },
  RSD: { currency: "RSD", name: "Serbian Dinar", countryCode: "RS" },
  RUB: { currency: "RUB", name: "Russian Ruble", countryCode: "RU" },
  RWF: { currency: "RWF", name: "Rwandan Franc", countryCode: "RW" },
  SAR: { currency: "SAR", name: "Saudi Riyal", countryCode: "SA" },
  SBD: { currency: "SBD", name: "Solomon Islands Dollar", countryCode: "SB" },
  SCR: { currency: "SCR", name: "Seychellois Rupee", countryCode: "SC" },
  SDG: { currency: "SDG", name: "Sudanese Pound", countryCode: "SD" },
  SEK: { currency: "SEK", name: "Swedish Krona", countryCode: "SE" },
  SGD: { currency: "SGD", name: "Singapore Dollar", countryCode: "SG" },
  SHP: { currency: "SHP", name: "Saint Helena Pound", countryCode: "SH" },
  SLE: { currency: "SLE", name: "Sierra Leonean Leone", countryCode: "SL" },
  SLL: { currency: "SLL", name: "Sierra Leonean Leone", countryCode: "SL" },
  SOS: { currency: "SOS", name: "Somali Shilling", countryCode: "SO" },
  SRD: { currency: "SRD", name: "Surinamese Dollar", countryCode: "SR" },
  SSP: { currency: "SSP", name: "South Sudanese Pound", countryCode: "SS" },
  STN: {
    currency: "STN",
    name: "São Tomé and Príncipe Dobra",
    countryCode: "ST",
  },
  SYP: { currency: "SYP", name: "Syrian Pound", countryCode: "SY" },
  SZL: { currency: "SZL", name: "Swazi Lilangeni", countryCode: "SZ" },
  THB: { currency: "THB", name: "Thai Baht", countryCode: "TH" },
  TJS: { currency: "TJS", name: "Tajikistani Somoni", countryCode: "TJ" },
  TMT: { currency: "TMT", name: "Turkmenistani Manat", countryCode: "TM" },
  TND: { currency: "TND", name: "Tunisian Dinar", countryCode: "TN" },
  TOP: { currency: "TOP", name: "Tongan Paʻanga", countryCode: "TO" },
  TRY: { currency: "TRY", name: "Turkish Lira", countryCode: "TR" },
  TTD: {
    currency: "TTD",
    name: "Trinidad and Tobago Dollar",
    countryCode: "TT",
  },
  TVD: { currency: "TVD", name: "Tuvaluan Dollar", countryCode: "TV" },
  TWD: { currency: "TWD", name: "New Taiwan Dollar", countryCode: "TW" },
  TZS: { currency: "TZS", name: "Tanzanian Shilling", countryCode: "TZ" },
  UAH: { currency: "UAH", name: "Ukrainian Hryvnia", countryCode: "UA" },
  UGX: { currency: "UGX", name: "Ugandan Shilling", countryCode: "UG" },
  UYU: { currency: "UYU", name: "Uruguayan Peso", countryCode: "UY" },
  UZS: { currency: "UZS", name: "Uzbekistani Som", countryCode: "UZ" },
  VES: { currency: "VES", name: "Venezuelan Bolívar", countryCode: "VE" },
  VND: { currency: "VND", name: "Vietnamese Đồng", countryCode: "VN" },
  VUV: { currency: "VUV", name: "Vanuatu Vatu", countryCode: "VU" },
  WST: { currency: "WST", name: "Samoan Tala", countryCode: "WS" },
  XAF: {
    currency: "XAF",
    name: "Central African CFA Franc",
    countryCode: "CM",
  },
  XCD: { currency: "XCD", name: "East Caribbean Dollar", countryCode: "AG" },
  XOF: {
    currency: "XOF",
    name: "West African CFA Franc",
    countryCode: "SN",
  },
  XPF: { currency: "XPF", name: "CFP Franc", countryCode: "PF" },
  YER: { currency: "YER", name: "Yemeni Rial", countryCode: "YE" },
  ZAR: { currency: "ZAR", name: "South African Rand", countryCode: "ZA" },
  ZMW: { currency: "ZMW", name: "Zambian Kwacha", countryCode: "ZM" },
  ZWL: { currency: "ZWL", name: "Zimbabwean Dollar", countryCode: "ZW" },
};

export const CURRENCY_LIST = Object.entries(CURRENCY_MAP).map(
  ([key, value]) => ({
    ...value,
  })
);

export default CURRENCY_MAP;
